import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-add-asset',
  templateUrl: './add-asset.component.html',
  styleUrls: ['./add-asset.component.scss'],
})
export class AddAssetComponent implements OnInit {

  assetForm!: FormGroup;
  authorities: any[] = [];
  allListingband: any = [];
  buttonColorName: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInUserRole: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserName: any | null;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  autorityListData: any;
  assetGetDataFronAnotherCoponent: any;
  dropdownSettings: IDropdownSettings = {};
  selectedBand: any;
  preSelectedBandItems: any;
  selectedBandsList: any = [];
  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<AddAssetComponent>,
    @Inject(MAT_DIALOG_DATA) public assetdata: any, private config: Config, private encryptionService: EncryptionService,
    private httpService: HttpService, public dialog: MatDialog,) {

    this.assetGetDataFronAnotherCoponent = assetdata
    this.assetForm = this.fb.group({
      employeeName: ['', Validators.required],
      userd: [],
      isActive: [true],
      assetName: ['', Validators.required],
      band: ['', Validators.required],
      allocatingDep: ['', Validators.required],
      assetId: []

    });
    // Patch data into the form


    if (this.assetGetDataFronAnotherCoponent?.data) {
      this.patchAssetForm(this.assetGetDataFronAnotherCoponent.data);
    }

  }
  // Method to patch the data into the form
  patchAssetForm(data: any): void {
    const formattedBands = (data.bands || []).map((band: any, index: any) => {
      return { id: index, band: band };
    });

    this.assetForm.patchValue({
      employeeName: data.authorityName || '',
      assetAuthorityId: data.authorityId || '',
      assetName: data.assetName || '',
      band: formattedBands || '',
      allocatingDep: data.authorityId || '',
      assetId: data.assetId || '',


      isActive: data.isDeleted === false // Set active based on isDeleted value
    });
    console.log(this.assetForm.value);

  }
  ngOnInit() {


    this.buttonColorName = sessionStorage.getItem('buttonColorName');

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;


    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.getAutorityListingData();
    this.getBandList()
    if (this.assetGetDataFronAnotherCoponent.assetId != null) {
      this.assetAllocationData();

    }
    // this.dropdownSettings = {
    //   singleSelection: false,
    //   idField: 'id',
    //   textField: 'band',
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   itemsShowLimit: 1,
    //   allowSearchFilter: true
    // };
    this.dropdownSettings = {
      idField: 'id',
      textField: 'band',
      disabledField: 'disabled', // Field for disabling items
      allowSearchFilter: true,  // Optional: Allow search
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      enableCheckAll: true,     // Optional: Enable select all
      singleSelection: false,   // Multiple selection
    };

  }

  hasError(controlName: any, errorType: any) {
    const control = this.assetForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }


  getAutorityListingData() {
    this.httpService.callGetService(`${this.config.listingAssetAuthority}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.assetGetDataFronAnotherCoponent.year}`)
      .subscribe((elm: any) => {
        this.autorityListData = elm.data;

      })

  }
  onEmployeeChange(authorityId: any) {


    const employeeName = this.autorityListData.filter((elm: any) => elm.assetAuthorityId == authorityId.value);
    if (employeeName) {
      this.assetForm.patchValue({
        employeeName: employeeName[0].employeeName || '',
        userId: employeeName[0].userId || ''
      });
    }

  }


  selectedBandsListData: any = []
  getBandList() {
    console.log("getBandList");
    this.httpService.callGetService(`${this.config.getBand}/${this.loggedInUserCompanyID}`).subscribe(
      (record: any) => {
        // Initialize allListingband
        this.allListingband = record.data.map((elm: any, index: any) => ({
          id: index,
          band: elm,
          disabled: false, // Default to enabled
        }));

        if (this.assetGetDataFronAnotherCoponent.data != null) {
          const assetFromData = this.assetGetDataFronAnotherCoponent.data;
          const selectBandLists = assetFromData.bands; // Selected bands list


          // Map selected bands to their full objects from allListingband
          this.selectedBandsListData = this.allListingband.filter((band: any) =>
            selectBandLists.includes(band.band)
          );

          // Update allListingband: Disable only selected bands
          this.allListingband = this.allListingband.map((band: any) => ({
            ...band,
            disabled: selectBandLists.includes(band.band), // Disable if in the selected list
          }));

          // Pre-check the selected bands in the dropdown
          this.selectedBandsList = this.selectedBandsListData.map((band: any) => ({
            id: band.id,
            band: band.band,
          }));
          ;
        }
      }
    );
  }

  // When a band is selected
  onBandSelect(selectedBand: any) {

    if (!selectedBand.disabled) {
      this.selectedBandsList.push(selectedBand);
    }
  }

  // When a band is deselected
  onBandDeselect(deselectedBand: any) {

    if (!deselectedBand.disabled) {
      this.selectedBandsList = this.selectedBandsList.filter(
        (band: any) => band.id !== deselectedBand.id
      );
    }
  }

  selectAllDept(items: any): void {
    this.selectedBand = items;
    this.getBandList();
  }
  onDeSelectAllDept() {
    this.selectedBand = [];
  }
  saveassetData() {
    let bandList: any[] = [];


    const band = this.assetForm.value.band.map((elm: any) => {
      if (!bandList.includes(elm.band)) {
        bandList.push(elm.band)
      }
    });


    let formData = {
      "assetName": this.assetForm.value.assetName,
      "bands": bandList,
      "authorityId": this.assetForm.value.allocatingDep,
      "companyId": this.loggedInUserCompanyID,
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "year": this.assetGetDataFronAnotherCoponent.year
    }
    this.httpService.callPostService(`${this.config.saveAsset}`, formData).subscribe(
      (data: any) => {
        if (data) {
          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close();
          });
        }
      },
      (error: any) => {

        const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: error.error.error || 'An error occurred while processing your request. Please try again.',
            btn2: 'OK',
            btn2BgColor: 'red', // Highlight error with red button color
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: true
          }
        });

        errorDialogRef.afterClosed().subscribe(() => {
          // Optionally handle any action after closing the error dialog
          console.log('Error dialog closed');
        });
      }
    );

  }
  updateAsset() {
    let updateData = this.assetForm.value;
    let bandList: any[] = [];


    const band = this.assetForm.value.band.map((elm: any) => {
      if (!bandList.includes(elm.band)) {
        bandList.push(elm.band)
      }
    });

    let formData = {

      "assetName": updateData.assetName,
      "bands": bandList,
      "authorityId": updateData.allocatingDep,
      "companyId": this.loggedInUserCompanyID,
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "year": this.assetGetDataFronAnotherCoponent.year
    }

    console.log(this.assetForm.value);

    this.httpService.callPutService(`${this.config.updateAsset}/${updateData.assetId}`, formData).subscribe(
      (data: any) => {
        console.log(data);

        if (data) {
          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close();
          });
        }
      },
      (error: any) => {

        const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: error.error.error || 'An error occurred while processing your request. Please try again.',
            btn2: 'OK',
            btn2BgColor: 'red', // Highlight error with red button color
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: true
          }
        });

        errorDialogRef.afterClosed().subscribe(() => {
          // Optionally handle any action after closing the error dialog
          console.log('Error dialog closed');
        });
      }
    );
  }
  cancelbutton() {
    this.dialogRef.close();
  }

  // ------------------------------------------------------------------------------My Asset -----------------------------------------------------------------------------------------------------
  allocatingAssetEmployee: any = [];

  allocatingEmployee: any = [];
  assetOptions = [
    "RECEIVED ASSET",
    "REPAIR ASSET",
    "RETURNING ASSET DUE TO EXIT",
    "RECEIVED AFTER REPAIR"
  ];
  assetAllocationlistForEmployee: any = [];
  assetAllocationData() {
    this.httpService.callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.assetGetDataFronAnotherCoponent.year}`)
      .subscribe((elm: any) => {
        console.log(elm);
        this.assetAllocationlistForEmployee = elm.data;

        this.getDateByEmployeeName();

      })

  }
  getDateByEmployeeName() {
    console.log(this.assetAllocationlistForEmployee);

    console.log(this.loggedInUserId);

    this.allocatingAssetEmployee = this.assetAllocationlistForEmployee.filter((record: any) => record.assetId == this.assetGetDataFronAnotherCoponent.assetId);
    console.log(this.allocatingAssetEmployee);

    const assetMap = new Map<string, any>();

    // Loop through the original assets and group by asset name
    for (const asset of this.allocatingAssetEmployee) {
      if (assetMap.has(asset.assetName)) {
        // If asset name already exists, merge the users
        const existingAsset = assetMap.get(asset.assetName);
        existingAsset.users.push({
          assetName: asset.assetName,
          band: asset.band,
          assetId: asset.assetId,
          userId: asset.userId,
          employeeName: asset.employeeName,
          employeeComment: asset.employeeComment,
          currentAssetDescription: asset.currentAssetDescription,
          authorityDepartmentComment: asset.authorityDepartmentComment,
          // Corrected property name
          employeeAssetStatus: asset.employeeAssetStatus,
          employeeCommentDate: asset.employeeCommentDate,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.allocatingAuthorityName,
          allocatingAuthorityDept: asset.allocatingAuthorityDept,
          authorityCommentDate: asset.authorityCommentDate
        });
      } else {
        // If asset name doesn't exist, add it to the map
        assetMap.set(asset.assetName, {
          assetName: asset.assetName,
          band: asset.band,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.allocatingAuthorityName,
          isExpand: false,
          users: [{
            assetName: asset.assetName,
            band: asset.band,
            userId: asset.userId,
            assetId: asset.assetId,
            employeeName: asset.employeeName,
            employeeComment: asset.employeeComment,
            currentAssetDescription: asset.currentAssetDescription,
            authorityDepartmentComment: asset.authorityDepartmentComment,
            // Corrected property name
            employeeAssetStatus: asset.employeeAssetStatus,
            employeeCommentDate: asset.employeeCommentDate,
            dateOfAllocation: asset.dateOfAllocation,
            allocatingAuthorityName: asset.allocatingAuthorityName,
            allocatingAuthorityDept: asset.allocatingAuthorityDept,
            authorityCommentDate: asset.authorityCommentDate
          }]
        });
      }
    }

    // Convert the map to an array
    this.allocatingEmployee = Array.from(assetMap.values());

    console.log(this.allocatingEmployee);

  }


  // 


}
